module.exports = __webpack_public_path__ + "img/in.b80ba562.svg";